import { CREATE_BATCH } from './batch$';
import { CoordinatorService } from './coordinator.service';
import { ScriptBatch } from './script-batch';

export type RUN_TYPE = 'fulltexts' | 'run';

export class Batch {
    id: string;
    private _payload: any;

    constructor(
        public coords: CoordinatorService,
        { id, payload }: CREATE_BATCH = {},
    ) {
        this.id = id || this.coords.uniqueId();
        this._payload = payload;
    }

    async start() {
        this.run('run', this._payload);
    }

    async run(tp: RUN_TYPE, payload: any) {
        this.coords.worker$.batch.call(tp, {
            projectId: this.coords.project$.currentId,
            batchId: this.id,
            payload,
        });
    }

    async test() {
        this.coords.worker$.batch.call('test', { type: 'TEST', payload: this._payload });
    }

    get scriptClass() {
        return new ScriptBatch(this.coords, this);
    }
}
